var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectbookingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3275 106.887L39.2475 103.798L57.9425 61.07L33.5875 65.94L30.135 62.1025L45.1325 14.1025L47.995 11.9975H80.995L83.5425 16.58L68.4125 40.935L92.7625 39.0075L95.33 43.885L44.3275 106.885V106.887ZM62.41 54.0575L65.7475 58.2025L53.6625 85.8225L86.2725 45.5425L62.97 47.3875L60.185 42.8125L75.6 18H50.2025L37.3725 59.065L62.4125 54.0575H62.41Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectbookingOutline);
export default __webpack_public_path__ + "static/media/Directbooking_outline.44fa0a0d.svg";
export { ForwardRef as ReactComponent };